import {AsyncPipe, NgClass, NgComponentOutlet}               from '@angular/common';
import {HttpClient}                                          from '@angular/common/http';
import {AfterViewInit, Component, inject}                    from '@angular/core';
import {Functions, httpsCallable}                            from '@angular/fire/functions';
import {AsstDataIntf, GlobalDataTypesDict, OutgoingDataIntf} from '@djsharkk/logr-types';
import {IconName}                                            from '@fortawesome/fontawesome-common-types';
import {DateTime}                                            from 'luxon';
import {lastValueFrom}                                       from 'rxjs';
import {v4 as uuidv4}                                        from 'uuid';
import {StatusItemIntf, UiStatusItemComponent}               from '../../../comps/ui/ui-status-item/ui-status-item.component';
import {UiVideoBgComponent}                                  from '../../../comps/ui/ui-video-bg/ui-video-bg.component';
import {MenuPanelBase}                                       from '../../utils/menu-panel-base';

@Component({
			   selector   : 'app-menu-crud',
			   imports    : [
				   NgClass,
				   NgComponentOutlet,
				   UiStatusItemComponent,
				   AsyncPipe,
				   UiVideoBgComponent
			   ],
			   templateUrl: './menu-crud.component.html',
			   styleUrl   : './menu-crud.component.css'
		   })
export class MenuCrudComponent extends MenuPanelBase implements AfterViewInit {

	tabItems: {
		uuid: string;
		icon: IconName;
		func: () => void;
	}[] = [
		/*{
		 uuid: uuidv4(),
		 icon: 'cog',
		 func: () => console.log('dashboard click')
		 },*/
		{
			uuid: uuidv4(),
			icon: 'bars',
			func: () => {
				this.svcMenuBase.svcMenuCrud.menuOpen.next(false);
				this.svcMenuBase.svcMenuCrud.menuType.next(undefined);
				this.svcMenuBase.svcMenuDrag.menuOpen.next(!this.svcMenuBase.svcMenuDrag.menuOpen.getValue());
				this.svcMenuBase.svcMenuDrag.menuType.next('log');
			}
		}
	]


	sumItemsR: StatusItemIntf = {
		uuid: uuidv4(),
		icon: GlobalDataTypesDict.vape.icon,
		text: null
	}

	viewHome: StatusItemIntf = {
		uuid: uuidv4(),
		text: 'HOME'
	}

	viewDays: StatusItemIntf = {
		uuid: uuidv4(),
		text: 'DAYS'
	}


	sumItemsMeds: [StatusItemIntf, StatusItemIntf] = [
		{
			uuid: uuidv4(),
			icon: 'sunrise',
			text: null
		},
		{
			uuid: uuidv4(),
			icon: 'sunset',
			text: null
		}

	]

	downloadButton: StatusItemIntf = {
		uuid: uuidv4(),
		icon: 'download',
		text: 'Download Data'
	}

	http = inject(HttpClient)

	v: {
		version?: string
	} = {
		version: '0'
	}

	constructor(
		private functions: Functions
	) {
		super();
	}


	getManifest() {
		return this.http.get<{
			version?: string
		}>('/manifest.webmanifest');
	}

	/**
	 * Downloads the last 7 days of aggregated data as a JSON file
	 */

	ngAfterViewInit() {

		lastValueFrom(this.getManifest()).then(data => {
			this.v = data
			console.log('App version:', data.version)
		});


	}


	async downloadSevenDayData() {
		const dateStart = DateTime.now().minus({days: 7}).startOf('day');
		const dateEnd = DateTime.now().startOf('day');

		const getData = httpsCallable<OutgoingDataIntf, AsstDataIntf>(this.functions, 'getSevenDayHistory');
		const data = await getData({
									   dateStart: dateStart.toJSDate(),
									   dateEnd  : dateEnd.toJSDate()
								   });

		this.downloadStringAsJson(`logr-data_${dateStart.toISODate()}-${dateEnd.toISODate()}.json`, data.data);

	}

	downloadStringAsJson(filename: string, jsonString: Object) {
		// Create a blob with the JSON string
		const blob = new Blob([
								  JSON.stringify(
									  jsonString,
									  null,
									  2
								  )
							  ], {type: 'application/json'});

		// Create a download link
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = filename;

		// Programmatically click the link to trigger the download
		document.body.appendChild(link); // Append to DOM for Firefox compatibility
		link.click();

		// Clean up
		document.body.removeChild(link); // Remove link element after clicking
		URL.revokeObjectURL(link.href); // Release the blob URL
	}


}
